/** Склонение «проверка» по числу: 1 проверка, 2 проверки, 5 проверок. */
export function checksWord(n: number): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return "проверка";
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return "проверки";
  return "проверок";
}

/** Дата окончания демо: «2 ноября». */
export function demoUntil(iso: string): string {
  return new Date(iso).toLocaleDateString("ru-RU", { day: "numeric", month: "long" });
}

/**
 * Страницы, скрытые в демо-кабинете: проверка организации (синтетики по
 * юрлицам нет, /v2/check/legal для демо закрыт) и проверка транспорта.
 */
export const DEMO_HIDDEN_PAGES: ReadonlySet<string> = new Set(["company_check", "vehicle_check"]);
